<div class="container">
  <div class="header-row">
    <div class="title-row">
      <h2 class="section-title">MIPS Submission Review Management</h2>
      @if (loading$ | async) {
        <span class="loading-label">Loading...</span>
      }
    </div>
  </div>

  <div class="content">
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      [columnDefs]="colDefs"
      [rowData]="rowData$ | async"
      [loading]="loading$ | async"
      [defaultColDef]="defaultColDef"
      [suppressCellFocus]="true"
      [theme]="theme"
      [gridOptions]="gridOptions"
      (cellClicked)="onCellClicked($event)"
    />
  </div>

  <label class="hide-submitted-toggle">
    <input type="checkbox" [formControl]="hideSubmittedControl" />
    Hide Submitted
  </label>
</div>
